import { Link } from 'react-router-dom';
import { Reveal, Eyebrow } from './Shared';
import { services } from '../data/content';
import { L } from '../i18n/LocaleProvider';

// Answer-ready, factual copy for search engines and AI answer engines.
export const entityStatement = 'TechSpitze is a Canadian IT consulting and technology company headquartered in Canada, with delivery teams across five countries. We provide AI automation, digital transformation, enterprise technology, software and digital product engineering, and digital growth services for growing businesses, enterprises and public-sector organisations.';

export const faqs = [
  { q: 'What does TechSpitze do?', a: 'TechSpitze is an IT consulting and technology company that delivers AI automation, digital transformation, enterprise technology, custom software and digital growth services. We work from strategy through to production delivery and ongoing support.' },
  { q: 'Where is TechSpitze based?', a: 'TechSpitze is headquartered in Canada and serves clients across five countries. Canadian clients work with a local team, supported by global delivery capacity.' },
  { q: 'What is AI automation?', a: 'AI automation uses artificial intelligence to carry out work that people currently do by hand — reading documents, entering data, answering routine questions and moving information between systems. We automate the repeatable path and route exceptions to a person for review.' },
  { q: 'How long does a digital transformation project take?', a: 'A focused automation or modernisation project typically delivers its first measurable result in 6 to 12 weeks. Larger, multi-system transformation programmes usually run 6 to 18 months, delivered in waves so value arrives early.' },
  { q: 'Do you work with government and public-sector clients?', a: 'Yes. We work with public-sector organisations and partner with Government of Canada vendor partners. Engagements follow the accessibility, privacy and security requirements that public bodies are held to.' },
  { q: 'Which industries does TechSpitze serve?', a: 'We work across logistics and supply chain, healthcare, financial services, manufacturing, retail, professional services and the public sector, alongside startups and small businesses scaling their operations.' },
  { q: 'How much does an engagement cost?', a: 'Scope drives cost. Most first engagements fall between CAD 25,000 and 100,000, and smaller proof-of-value projects start lower. We give a written estimate after a discovery conversation.' },
  { q: 'How do I start a project?', a: 'Complete the Intake Form with a short description of your processes, systems and goals, or send us a message from the contact page. We respond within one business day and follow up with a discovery call.' },
];

export const GeoSections = () => <L><>
  <section className="container geo-entity" aria-labelledby="what-is-techspitze">    <Reveal>
      <Eyebrow id="geo-entity-eyebrow">IN PLAIN TERMS</Eyebrow>
      <h2 id="what-is-techspitze" data-testid="geo-entity-heading">What is TechSpitze?</h2>
      <p className="geo-entity-copy" data-testid="geo-entity-statement">{entityStatement}</p>
    </Reveal>
  </section>

  <section className="container geo-glance" aria-labelledby="services-at-a-glance">
    <Reveal>
      <h2 id="services-at-a-glance" data-testid="geo-glance-heading">Services at a glance</h2>
      <ul className="geo-glance-list" data-testid="geo-glance-list">
        {services.map(service => <li key={service.id}>
          <h3>{service.name}</h3>
          <p>{service.description}</p>
          <Link to={`/services#${service.id}`} data-testid={`geo-glance-link-${service.id}`}>Read about {service.name}</Link>
        </li>)}
      </ul>
    </Reveal>
  </section>
</></L>;

export const GeoFaq = () => <L><section className="container geo-faq geo-faq-standalone" aria-labelledby="faq-heading">
  <Reveal>
    <Eyebrow id="geo-faq-eyebrow">FREQUENTLY ASKED</Eyebrow>
    <h2 id="faq-heading" data-testid="geo-faq-heading">Questions we hear most</h2>
    <div className="geo-faq-list" data-testid="geo-faq-list">
      {faqs.map((item, i) => <div className="geo-faq-item" key={item.q} data-testid={`geo-faq-item-${i}`}>
        <h3>{item.q}</h3>
        <p>{item.a}</p>
      </div>)}
    </div>
  </Reveal>
</section></L>;
